import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  iframeLoading: false,
  iframeData: false
};

const IframeSlice = createSlice({
  name: "sportsIframe",
  initialState,
  reducers: {
    getlaunchIframeStart: (state, action) => {
      state.iframeLoading = true;
    },
    getlaunchIframeSuccess: (state, action) => {
      state.iframeLoading = false;
      state.iframeData = action?.payload;
    },
    getlaunchIframeFailure: (state, action) => {
      state.iframeLoading = false;
    }
  }
});

export const {
  getlaunchIframeStart,
  getlaunchIframeSuccess,
  getlaunchIframeFailure
} = IframeSlice.actions;

export default IframeSlice.reducer;
